function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  r: 55.935,
  transform: "matrix(-1 0 0 1 56.81 61.254)",
  fill: "#D7D5EF"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M106.582 86.136a29.92 29.92 0 0 0-12.255-2.58l-35.926.09c-2.52.005-5.015.488-7.355 1.42L15.468 99.249c10.21 11.033 24.814 17.941 41.031 17.941 21.946 0 40.937-12.649 50.083-31.053z",
  fill: "#09CAC7"
});

var _ref4 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 55.16,
  cy: 85.472,
  rx: 38.301,
  ry: 20.806,
  transform: "rotate(-10.657 55.16 85.472)",
  fill: "#09CAC7"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M23.74 100.045c9.212 5.484 23.623 10.471 41.659 6.596 12.02-2.583 21.923-11.343 25.723-19.276",
  stroke: "#000",
  strokeLinecap: "round"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "m79.191 100.677 2.424 10.498M50.179 107.58l1.722 9.255",
  stroke: "#000"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "m32.577 7.216 15.868 15.558-17.062 15.16c-1.026-2.178-4.229-9.082-4.328-14.691-.117-6.57 2.361-12.25 3.884-15.708a1.017 1.017 0 0 1 1.638-.32z",
  fill: "#000",
  stroke: "#000"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M38.208 22.91c-1.573-2.69-4.908-9.04-5.178-14.253l15.185 15.581-4.12 6.527s-4.314-5.163-5.887-7.854z",
  fill: "#fff"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "m27.805.77 7.115 8.528-10.264-4.095L27.805.77z",
  fill: "#000"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M90.21 12.155 72.973 25.464l14.873 16.741c1.251-2.003 5.17-8.36 5.915-13.813.87-6.372-.878-12.18-1.962-15.728a1.017 1.017 0 0 0-1.59-.51z",
  fill: "#000",
  stroke: "#000"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M90.774 11.787c-.864 5.048-4.037 10.809-5.881 13.25-1.844 2.44-6.644 6.972-6.644 6.972",
  stroke: "#000"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M83.528 26.535c1.879-2.487 5.938-8.4 6.82-13.544L73.434 26.675l3.322 6.966s4.892-4.619 6.772-7.106z",
  fill: "#fff"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "m95.624 6.41-7.997 7.487 10.553-2.805-2.556-4.683z",
  fill: "#000"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "m40.988 78.14 2.267-18.56c5.959-.428 19.26-.923 24.796.529 5.536 1.45 4.064 2.582 3.678 9.117l-.414 7.003-.358 6.05c-1.954 2.726-6.065 8.167-16.866 6.582-6.704-.984-11.072-5.449-13.103-10.722z",
  fill: "#fff",
  stroke: "#000"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "M88.397 52.944c-1.898 7.179-7.53 13.129-13.846 17.23-6.325 4.107-13.219 6.285-17.527 6.03-2.136-.126-4.722-.95-7.472-2.304-2.743-1.35-5.618-3.21-8.323-5.375-5.426-4.344-10.089-9.848-11.677-14.82-3.187-9.975.546-18.285 7.064-24.022 6.54-5.756 15.847-8.88 23.654-8.419 7.79.46 15.79 4.79 21.365 10.838 5.578 6.051 8.643 13.724 6.762 20.842z",
  fill: "#fff",
  stroke: "#000"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "M38.432 42.993a19.211 19.211 0 0 1-.176-.657 20.882 20.882 0 0 1 3.18-.983c2.05-.453 4.478-.623 6.314.316 1.835.939 3.119 3.007 3.952 4.935a20.888 20.888 0 0 1 1.063 3.153 20.882 20.882 0 0 1-3.18.983c-2.05.454-4.478.623-6.313-.316-1.836-.939-3.12-3.006-3.952-4.935-.411-.951-.701-1.842-.888-2.496z",
  fill: "#09CAC7",
  stroke: "#000"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M37.398 41.488s5.672-3.1 9.667-1.057M83.383 45.025s-4.952-3.89-9.994-2.237",
  stroke: "#000",
  strokeWidth: 3
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "M48.57 42.124c3.477 2.21 6.96 15.84 6.96 15.84l8.403.496c1.908-3.287 6.213-15.06 11.407-14.754",
  stroke: "#000"
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  d: "M81.986 46.321c.092-.22.167-.409.224-.559a19.42 19.42 0 0 0-2.8-1.24c-1.846-.644-4.063-1.063-5.851-.4-1.789.661-3.197 2.424-4.178 4.114a19.418 19.418 0 0 0-1.317 2.767 19.433 19.433 0 0 0 2.801 1.24c1.846.644 4.063 1.063 5.85.4 1.789-.662 3.198-2.424 4.178-4.115a19.41 19.41 0 0 0 1.093-2.207z",
  fill: "#09CAC7",
  stroke: "#000"
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  d: "M60.188 63.797a1 1 0 0 1-1.568-.093l-3.707-5.327a1 1 0 0 1 .88-1.57l8.015.474a1 1 0 0 1 .689 1.662l-4.309 4.854zM44.521 46.505c-.235-2.933 1.14-5.258 1.14-5.258l1.666-.04 2.184.931c.078.978.378 3.199-.28 4.727-.657 1.53-1.7 2.73-2.924 2.45-.754-.174-1.637-.955-1.786-2.81zM74.796 48.6c-.304-2.532.807-4.591.807-4.591l3.421.232c.101.844.38 3.164-.138 4.51-.517 1.346-1.38 2.42-2.449 2.22-.658-.124-1.45-.77-1.641-2.371z",
  fill: "#000"
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  d: "M51.12 61.45a8.421 8.421 0 0 0 15.848.937",
  stroke: "#000",
  strokeLinecap: "round"
});

var _ref22 = /*#__PURE__*/React.createElement("path", {
  d: "m59.54 61.479-.36 6.067",
  stroke: "#000"
});

var _ref23 = /*#__PURE__*/React.createElement("path", {
  d: "M47.426 31.403c.32-.51.947-.737 1.52-.55l5.693 1.86A2.05 2.05 0 1 1 52.91 36.4l-5.072-3.186a1.313 1.313 0 0 1-.413-1.81zM75.395 34.514a1.313 1.313 0 0 0-1.253-1.02l-5.988-.12a2.05 2.05 0 1 0 .415 4.048l5.839-1.335a1.313 1.313 0 0 0 .987-1.573z",
  fill: "#000"
});

function SvgMascotAvatar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 113,
    height: 118,
    viewBox: "0 0 113 118",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMascotAvatar);
export default __webpack_public_path__ + "static/media/mascot_avatar.9dd0ade9.svg";
export { ForwardRef as ReactComponent };